import { frontendURL } from '../../../helper/URLHelper';
import Inmuebles from './Inmuebles.vue';

const meta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/actibid/inventario'),
    name: 'actibid_inventario_index',
    component: Inmuebles,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/actibid/inmuebles'),
    redirect: to => ({
      name: 'actibid_inventario_index',
      params: { accountId: to.params.accountId },
    }),
  },
];
